import { Apple } from "lucide-react";

const BADGES = {
  mada: <span className="font-bold tracking-tight"><span className="text-[#1A4F9C]">ma</span><span className="text-[#84B740]">da</span></span>,
  visa: <span className="font-extrabold italic text-[#1A1F71] tracking-tight">VISA</span>,
  mastercard: <span className="flex items-center"><span className="w-3.5 h-3.5 rounded-full bg-[#EB001B]" /><span className="w-3.5 h-3.5 rounded-full bg-[#F79E1B] -ms-1.5 mix-blend-multiply" /></span>,
  applepay: <span className="flex items-center gap-0.5 font-semibold text-[#0B0D0F]"><Apple className="w-3.5 h-3.5 fill-current" />Pay</span>,
  stcpay: <span className="font-bold text-[#4F008C]">stc pay</span>,
};

export const PaymentBadges = ({ methods = Object.keys(BADGES), className = "" }) => (
  <div data-testid="payment-badges" className={`flex flex-wrap items-center gap-2 ${className}`}>
    {methods.filter((m) => BADGES[m]).map((m) => (
      <span key={m} data-testid={`payment-badge-${m}`} className="h-8 min-w-[52px] px-2.5 rounded-md bg-white border border-[#E5E7EB] flex items-center justify-center text-xs" dir="ltr">{BADGES[m]}</span>
    ))}
  </div>
);
